import { Injectable, inject } from '@angular/core';
import {TreeDataService} from './tree-data.service';

@Injectable({
    providedIn: 'root'
})
export class SessionService {
    private readonly treeDataService = inject(TreeDataService);


    login() {
        this.reset();
    }

    logout() {
        this.reset();
    }

    // Reset service stockage
    reset() {
        this.treeDataService.reset();
    }
}
